import { API } from '../api'
import { CardParams } from './interface'

export const post = async (
  filtros: Record<string, any>
): Promise<{
  conteudo: string
  sucesso: boolean
  erros: string[]
}> => {
  try {
    const { id, ...restFiltros } = filtros
    const response = await API.post<CardParams>(
      `/logistica/item/atualizar-cartao/${id}`,
      restFiltros
    )

    return {
      conteudo: response.content,
      sucesso: response.isSuccess,
      erros: []
    }
  } catch (error) {
    console.error('Erro ao atualizar cartão:', error)
    return null
  }
}
